import styled from 'styled-components';
import Down_arrow from "../../../assests/images/arrow-down-black.svg";
import Up_arrow from "../../../assests/images/arrow-down-white.svg";

export const CardFilterBtn = styled.div`
    &.category-btn-group{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 15px;
        margin-bottom: 30px;
        @media screen and (max-width:767px) { 
            gap: 9px;
         }
        button{
            background: #FFFFFF;
            box-shadow: 0px 5px 20px #0000001A;
            border-radius: 15px;
            border: none;
            font-family: "Jost", sans-serif;
            font-size: 16px;
            font-weight: 500;
            line-height: 26px;
            color: #333333;
            padding: 12px 15px;
            
            &:hover, &.active {
                background: #01606F;
                color: #fff;
            }
            @media screen and (max-width:767px) {
                padding: 10px 12px;
                font-size: 15px;
                line-height: 20px;
                border-radius: 10px;
               box-shadow: 0px 5px 10px #0000001A; 
            }
        }
        .dropdown{
            button{
                display: flex;
                align-items: center;

                &:after{
                    content: "";
                    background-image:url(${Down_arrow});
                    background-size: 100% 100%;
                    background-repeat: no-repeat;
                    border: none;
                    width: 24px;
                    height: 24px;
                    margin-left: 10px;

                }

                &:hover{
                    background: #FFFFFF;
                    color: #333333;
                     &:after{
                         filter: invert(1) brightness(100);
                     }
                }
                &.active{
                    background-image:url(${Up_arrow});
                    transform: rotate(-180deg);
                }
            }
            .dropdown-menu{
                width: 320px;
                background: #FFFFFF;
                box-shadow: 0px 10px 30px #00000033;
                border-radius: 20px;
                margin: 10px 0;
                overflow: hidden;
                z-index: 1;
                .custom-scrollbar{
                    height: 287px;
                    overflow-y: auto;
                    padding: 30px 30px 20px 30px;

                    .dropdown-item {
                        padding: 0;
                        font-family: "Jost", sans-serif;
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 20px;
                        margin-bottom: 25px;
                        color: #000000;
                        background-color: transparent;

                        &:last-child{
                            margin-bottom: 0px;
                        }
                    }
                }
            }
        }
            
.dropdown-toggle:hover {
    background: #01606F !important;
    color: #fff !important;
}
    .active.dropdown .dropdown-toggle{
      background: #01606F !important;
      color: #fff !important;
         &:after{
            filter: invert(1) brightness(100);
         }
    }
    }
`;
